// extracted by mini-css-extract-plugin
module.exports = {"inputLabels":"FinalSubmissionLevel_inputLabels__opqfn","alertLabels":"FinalSubmissionLevel_alertLabels__11dJK"};